import { loadBookings } from "./bookings";

// A guest with a single live booking wants that booking, not a list of one. An ongoing
// stay wins over an upcoming one; past bookings never pull a guest in. Anything the rule
// cannot decide — no live bookings, or several of the same kind — lands on the list.
export const resolveLandingPath = async (userId) => {
    try {
        if (!userId) {
            return "/bookings";
        }

        const bookings = (await loadBookings(userId)) || [];

        const withStatus = (status) =>
            bookings.filter((booking) => booking?.current_user_status === status);

        const ongoing = withStatus("ONGOING");
        if (ongoing.length === 1) {
            return `/bookings/${ongoing[0].id}`;
        }

        if (ongoing.length === 0) {
            const upcoming = withStatus("UPCOMING");
            if (upcoming.length === 1) {
                return `/bookings/${upcoming[0].id}`;
            }
        }

        return "/bookings";
    } catch (error) {
        console.log(error);
        return "/bookings";
    }
};
